$(document).ready(function () {

    // ===============================
    // Scroll Fixed Class
    // ===============================
    window.addEventListener('scroll', function () {
        var scrollHeight = 350; // Change this value to the scroll height you desire
        var content = document.getElementsByClassName('bndlr-mnm-second-container')[0];
        if (content) {
            if (window.scrollY > scrollHeight) {
                content.classList.add('fixed');
            } else {
                content.classList.remove('fixed');
            }
        }
    });

    // ===============================
    // Variant Button Click Handler
    // ===============================
    $('body').on('click', '.wrapper__card .variantbtn-sec', function () {
        var dataPrice = $(this).data("price");
        var dataComparePrice = $(this).data("compareprice");
        var dataDiscount = $(this).data("discount");

        var popupContent = $(this).parents('.variants-popup-content');
        popupContent.find('.price-item.price-item--sale').text(dataPrice);
        popupContent.find('s.price-item.price-item--regular').text(dataComparePrice);
        popupContent.find('span.price-item.price-item--regular').text(dataPrice);

        $(this).parents('.product-item').find('.badge.sale-badge').text(dataDiscount);

        setTimeout(function () {
            $('.add-to-cart-btn').text("Add to Cart");
        }, 500);
    });

    // ===============================
    // Product Page Price Update (if product template)
    // =============================== 
        $('.productView-details .product-form__radio').click(function () {
            var dataPrice = $(this).data("price");
            var dataComparePrice = $(this).data("compareprice");
            var dataDiscount = $(this).data("discount");

            $('.mainprice-sec').text(dataPrice);
            $('.compareprice-sec').text(dataComparePrice);
            $(".productView-badge .badge.sale-badge").text(dataDiscount);
        }); 

    // ===============================
    // Heading Section Toggle
    // ===============================
    $(".headingsection").click(function () {
        $(this).toggleClass("active");
    });

    // ===============================
    // Home More / Less Toggle
    // ===============================
    function homeMoreLess() {
        if ($('#rich-text__lessMore').length) {
            $('#rich-text__lessMore').on('click', function () {
                var moreText = $(this).data('more').trim();
                var lessText = $(this).data('less').trim();
                var _parent = $(this).parents('.rich-text__content');

                if ($(this).text().trim() === moreText) {
                    _parent.find('.rich-text__bottom').slideDown(200);
                    $(this).text(lessText);
                } else {
                    _parent.find('.rich-text__bottom').slideUp(200);
                    $(this).text(moreText);
                }
            });
        }
    }
    homeMoreLess();

    // ===============================
    // Rebuy SmartCart Show
    // ===============================
    document.querySelector('.cart-icon-bubble')?.addEventListener('click', () => {
        if (typeof Rebuy !== 'undefined' && Rebuy.SmartCart) {
            Rebuy.SmartCart.show();
        }
    });

    // ===============================
    // Append/Prepend Menu Mobile
    // ===============================
    var appendPrependMenuMobile = function () {
        var headerLanguageCurrencyPC = $('.wrapper-language-currency'),
            headerLanguageCurrencyMB = $('.nav-currency-language'),
            headerSidebarLanguageCurrency = $('.halo-language-currency-sidebar .halo-sidebar-wrapper');

        if (window.innerWidth < 1025) {
            headerLanguageCurrencyPC.appendTo(headerLanguageCurrencyMB);
            if ($('.header-02').hasClass('style_2')) {
                $('.nav-currency-language .top-language-currency').appendTo('.header-language_currency');
            }
        } else {
            headerLanguageCurrencyPC.appendTo(headerSidebarLanguageCurrency);
            if ($('.header-02').hasClass('style_2')) {
                $('#halo-language-currency-sidebar .wrapper-language-currency .halo-top-language').appendTo('.top-language-currency');
                $('#halo-language-currency-sidebar .wrapper-language-currency .halo-top-currency').appendTo('.top-language-currency');
            }
        }
    };

    appendPrependMenuMobile();
    $(window).on('resize', appendPrependMenuMobile);

    if ($('.header-02').hasClass('style_2')) {
        $(document).on('click', '.header-language_currency', function () {
            $('.top-language-currency').toggleClass('show');
        });

        $(document).on('click', function (event) {
            if ($('.top-language-currency').hasClass('show') && ($(event.target).closest('.top-language-currency').length === 0)) {
                $('.top-language-currency').removeClass('show');
            }
        });
    }
 

    // Run only if URL matches
    if (window.location.href.indexOf('?customer_posted=true#NewsletterSection') !== -1) {
        
        var newsletterSuccessPopup = (function () {
            var popup = $('.newsletter-success-modal');
            var close = popup.find('.close');
            var success = popup.find('.success');
            var error = popup.find('.error');
            var overlay = $('.background-overlay');

            popup.show();
            overlay.show();
            error.hide();
            success.show();

            $.cookie('emailSubcribeModal', 'closed', {
                expires: 1,
                path: '/'
            });

            close.off('click').on('click', function () {
                popup.fadeOut();
                overlay.hide();
            });

            overlay.off('click').on('click', function () {
                popup.fadeOut();
                overlay.hide();
            });

        })();

        // Remove query from URL after running
        var newURL = location.href.split("?")[0];
        window.history.pushState({}, document.title, newURL);
    }
 
$(".videoinn-sec").click(function(){
  $(".videoinn-sec video").trigger('pause');
  $(".overlay").show();
  if($(this).hasClass("active")){
    $(this).removeClass("active");
    $(this).parents(".videosection-box").find("video").trigger('pause');
    $(this).parents(".videosection-box").find(".overlay").show();
  }else{
    $(this).addClass("active");
    $(this).parents(".videosection-box").find("video").trigger('play');
    $(this).parents(".videosection-box").find(".overlay").hide();
  }
  
})  

  $('.head').click(function(){
  $(this).toggleClass('active');
  $(this).parent().find('.arrow').toggleClass('arrow-animate');
  $(this).parent().find('.content').slideToggle(280);
});
});

setTimeout(() => {
  $(".header__icon.header__search").removeClass("pointevent-sec")
}, 2000)

setTimeout(() => {
  $(".header__icon--search").removeClass("pointevent-sec")
}, 2000)


// $('[data-search-desktop]').on('click', (event) => {
// event.preventDefault();
// $('body').addClass('open_search_desktop');
// });

if ($(window).width() > 1025) {
//alert("Hello");
$(".header__icon--search").click(function(){
    $('body').addClass('open_search_desktop');    
})

}else{
    $(".header__icon--search").click(function(){
    $('body').addClass('open_search_mobile');    
})
    
}